import { render } from "./TableauBordView.vue?vue&type=template&id=7de2d346"
import script from "./TableauBordView.vue?vue&type=script&lang=js"
export * from "./TableauBordView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__